// extracted by mini-css-extract-plugin
module.exports = {"inputError":"_2VRIP","inputWrapper":"_2RVD4"};